export default {
  "Chip": "_Chip_fkcdi_1",
  "RatingChip": "_RatingChip_fkcdi_60",
  "RatingIcon": "_RatingIcon_fkcdi_69",
  "CountChip": "_CountChip_fkcdi_74"
};import "ni:sha-256;h2B93hHrDRs0WNY-iajYVwY8qA8r7BARIbrF3_Cxv6I";